



























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Factura } from "@/typings/store/plugins/easyFirestore/facturas";
import { totalesDeItems } from "@/helpers/facturacion";
import {
  ItemNotaCredito,
  NotaCreditoFactura,
  TipoNotaCredito,
  acreditadoPorItem,
  armarNotaCredito,
  itemsNotaCredito,
  notasDeFactura,
  saldoFactura,
  validarNotaCredito,
} from "@/helpers/notasCredito";

@Component
export default class NotaCreditoFacturaDialogo extends Vue {
  @Prop({ required: true }) readonly factura!: Factura;
  /** Todas las notas de crédito (para el saldo y para no repetir folios). */
  @Prop({ default: () => [] }) readonly notasCredito!: NotaCreditoFactura[];
  @Prop({ type: Boolean, default: false }) readonly cargando!: boolean;

  tipo: TipoNotaCredito = "total";
  montos: Record<number, number> = {};
  motivo = "";
  folio: number | null = null;
  error = "";

  get previas(): NotaCreditoFactura[] {
    return notasDeFactura(this.notasCredito, this.factura.id);
  }

  get acreditadoPrevio(): number {
    return this.previas.reduce((s, n) => s + (Number(n.montoTotal) || 0), 0);
  }

  get saldo(): number {
    return saldoFactura(this.factura, this.notasCredito);
  }

  get items(): ItemNotaCredito[] {
    return itemsNotaCredito(this.factura, this.tipo, this.notasCredito, this.montos);
  }

  get totales(): { montoNeto: number; montoIva: number; montoTotal: number; montoExento?: number } {
    return totalesDeItems(this.items);
  }

  /** Total con folio, o parcial que completa lo que quedaba: la factura queda anulada. */
  get anulaFactura(): boolean {
    if (!this.folio || this.factura.estado !== "Emitida") return false;
    const previo = this.previas.filter((n) => n.estado === "Emitida").reduce((s, n) => s + n.montoNeto, 0);
    return this.totales.montoNeto + previo >= this.factura.montoNeto - 0.5;
  }

  disponible(i: number): number {
    const previo = acreditadoPorItem(this.previas);
    return Math.max(0, Math.round(this.factura.items[i].montoNeto - (previo[i] || 0)));
  }

  moneda(v: number): string {
    return new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(v || 0);
  }

  guardar(): void {
    const datos = { tipo: this.tipo, motivo: this.motivo, items: this.items, folio: this.folio || null };
    this.error = validarNotaCredito(this.factura, datos, this.notasCredito);
    if (this.error) return;
    this.$emit("guardar", { nota: armarNotaCredito(this.factura, datos), anulaFactura: this.anulaFactura });
  }
}
